import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleArrowUp, faArrowLeft} from "@fortawesome/free-solid-svg-icons";

import {BasicButton} from "../../common/Button";

export default function TopDownButton({onClick}) {
    return (
        <BasicButton
            onClick={onClick}
            className="not-selectable absolute top-2.5 left-1/2 transform -translate-x-1/2"
        >
            <FontAwesomeIcon icon={faArrowLeft} className="mr-2"/>
            Back
        </BasicButton>
    );
}